import React from 'react';

import { Suggestions } from '@mint-sdk/api-recommendations';

import { useBulkPublishMode } from '../../../contexts/BulkPublishModeContext.jsx';
import { useIsBulkPublishSelected } from '../../../hooks/useBulkPublishSelection.js';
import SeparateStatusChip from '../../atoms/SeparateStatusChip/SeparateStatusChip.jsx';

type Props = {
  suggestion: Suggestions.SuggestionResponseType;
};

const SuggestionCardStatus = ({ suggestion }: Props) => {
  const isBulkPublishMode = useBulkPublishMode();
  const isSelected = useIsBulkPublishSelected(suggestion.id);

  // Expired status has highest priority for visualization
  if (suggestion.status === Suggestions.Statuses.EXPIRED) {
    return <SeparateStatusChip type={Suggestions.Statuses.EXPIRED} />;
  }

  if (isBulkPublishMode && isSelected) {
    return <SeparateStatusChip type="ReadyForPublishing" />;
  }

  if (
    suggestion?.originalId &&
    suggestion.status === Suggestions.Statuses.ACTIVE
  ) {
    return <SeparateStatusChip type="ReworkedCard" />;
  }

  if (
    isBulkPublishMode &&
    suggestion.enabled &&
    suggestion.status === Suggestions.Statuses.ACTIVE
  ) {
    return <SeparateStatusChip type="Published" />;
  }

  if (suggestion.status === Suggestions.Statuses.ACTIVE) {
    return null;
  }

  return <SeparateStatusChip type={suggestion.status} />;
};

export default SuggestionCardStatus;
